import z from 'zod';
import {
  emailSchema,
  nameSchema,
  optionalStringSchema,
  phoneSchema,
  priceSchema,
  quantitySchema,
} from '../../validation';
import { itemPackingSchema, itemTypeSchema, temperatureSchema, vehicleTypesSchema, weightSchema } from '../../common';
import { orderPODCopySettingSchema } from '../order/order.settings.model';
import { orgWaybillSettingsSchema } from '../org/org.waybill-settings.model';

const contactPersonSchema = z.object({
  /** the email of the contact.  */
  email: emailSchema,
  /** the phone number of the contact if possible*/
  phone: phoneSchema.optional(),
  /** the name of the contact if possible */
  name: nameSchema.optional(),
});
/**
 * @deprecated Part of the legacy `Business` collection. The unified
 * `Org` collection carries its own settings shape; see `BusinessSchema`
 * for the full deprecation note.
 */
export const businessSettingsSchema = z.object({
  // ==== ITEMS SETTINGS ====

  /** the default item name that will be used in order. */
  item_default_name: optionalStringSchema(nameSchema).optional(),

  /** the default item type that will be used in order. */
  item_default_type: itemTypeSchema.optional(),

  /** the default cost of the item that will be used in order */
  item_default_cost: priceSchema.optional(),
  /** the default item weight in TONs. */
  item_default_weight: weightSchema.optional(),

  /** the default packing type (pallet, package, other). */
  item_default_packing: itemPackingSchema.optional(),

  /** the default quantity of items per vehicle. */
  item_default_quantity: quantitySchema.optional(),

  /** the default temperature preference for chilled/frozen vehicles. */
  item_default_temperature: temperatureSchema.optional(),

  // ==== Vehicle SETTINGS ====

  /** the default vehicle type that will be used in order.
   *
   * By default, if we have to choose one,,, we will always choose the first element in the array.
   */
  vehicle_preferred_types: z.array(vehicleTypesSchema).optional(),

  /** the customer proof of delivery (POD) settings */
  pod_settings: orderPODCopySettingSchema.optional(),

  // ==== Contacts ====
  /** the contacts that will be used to send financial reports to such as invoices.*/
  contacts_financial_reports: z.array(contactPersonSchema).optional(),
  /** the contacts that will be used to send operation reports to such as orders.*/
  contacts_operation_reports: z.array(contactPersonSchema).optional(),

  /** Carrier-branded HTML waybill settings (mirrors `Org.settings.waybill_settings`). */
  waybill_settings: orgWaybillSettingsSchema.optional(),
});
/** @deprecated See {@link businessSettingsSchema}. */
export type BusinessSettings = z.infer<typeof businessSettingsSchema>;
